module.exports = __webpack_public_path__ + "static/img/index16.037953d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index16.gif
// module id = 0zzV
// module chunks = 0